import { Alert, DotStatus, Section, Stack, Typography } from '@cmg/design-system';
import React, { ReactElement } from 'react';

export type Props = Readonly<{
  errors: string[];
  actionButtons: ReactElement[];
  isReleased: boolean;
  displayAllocationActions: boolean;
  sectionTitle: string;
}>;

const AllocationSection: React.FC<React.PropsWithChildren<Props>> = ({
  errors,
  actionButtons,
  displayAllocationActions,
  isReleased,
  sectionTitle,
  children,
}) => {
  return (
    <Section
      data-testid="read-allocation-view"
      title={sectionTitle}
      titleItems={
        isReleased ? (
          <div data-testid="allocation-released">
            <DotStatus color="success" label="Released" />
          </div>
        ) : (
          <div data-testid="allocation-unreleased">
            <DotStatus color="disabled" label="Unreleased" />
          </div>
        )
      }
      actions={displayAllocationActions ? actionButtons : []}
    >
      <Stack gap={1}>
        {errors.length > 0 && (
          <Alert severity="error">
            <Stack gap={1}>
              {errors.map((error, index) => (
                <Typography key={index} variant="body2">
                  {error}
                </Typography>
              ))}
            </Stack>
          </Alert>
        )}
        {children}
      </Stack>
    </Section>
  );
};

export default AllocationSection;
